// src/LandingRedirect.jsx
import { Navigate } from "react-router-dom";

export default function LandingRedirect() {
    const token = localStorage.getItem("access_token");
    return <Navigate to={token ? "/dashboard" : "/login"} replace />;
}
